export { default as en } from './en';

export const locales: Record<string, () => Promise<any>> = {
	en: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/cross-flow-support-i18n-en" */ './en'
		),
};
